<template>
    <div class="Information">
        <div class="row">
            <div class="col">
                <ActionButton :requires-confirmation="true"
                              confirmation-string="WARNING: You are about to delete this family's entire case file, and enrollment in this program.  This is the equivilant of shredding an entire file."
                              endpoint="Foster/ResourceFamily/DeleteFosterResourceFamily"
                              :payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id}"
                              :perform-global-update="true"
                              button-variant="danger"
                              button-string="DELETE FAMILY PROGRAM ENROLLMENT RECORD"
                              button-size="md"
                              v-on:success="OnFamilyDeleted" 
                              style="white-space: normal;"/>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    //import components
    import ActionButton from '../../../Core/ItemEditors/ActionButton.vue';

    export default {
        props: [
            'FamilyRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            OnFamilyDeleted() {
                this.$parent.$parent.CloseRecord("Families.FamilyProfiles.Remove","FamilyList",this.FamilyRecordData.Family.Id);
            }
        },
        components: {
            ActionButton
        },
        mounted() {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>